export class BiMultiMap<A, B> {
  private mapA: Map<A, B[]>;
  private mapB: Map<B, A[]>;

  public constructor() {
    this.mapA = new Map<A, B[]>();
    this.mapB = new Map<B, A[]>();
  }

  public add(a: A, b: B): void {
    this.mapA.set(a, [...(this.mapA.get(a) ?? []), b]);
    this.mapB.set(b, [...(this.mapB.get(b) ?? []), a]);
  }

  public remove(a: A, b: B): void {
    this.mapA.set(
      a,
      (this.mapA.get(a) ?? []).filter((value) => value !== b),
    );
    this.mapB.set(
      b,
      (this.mapB.get(b) ?? []).filter((value) => value !== a),
    );
  }

  public has(a: A, b: B): boolean {
    return (this.mapA.get(a) ?? []).includes(b) && (this.mapB.get(b) ?? []).includes(a);
  }

  public getBs(a: A): B[] {
    return [...(this.mapA.get(a) ?? [])];
  }

  public getAs(b: B): A[] {
    return [...(this.mapB.get(b) ?? [])];
  }
}
